import { Controller } from "@hotwired/stimulus"
import humanFileSize from '../human_file_size.js'

export default class extends Controller {
  static targets = [ "fileInput", "filePicker", "progressBar", "fileName", "fileSize", "sourceFileInput", "formContainer" ]

  async connect() {
  }

  filePickerTargetConnected() {
    this.startUppy()
  }

  async startUppy() {
    const Uppy = (await import('@uppy/core')).default
    const XHRUpload = (await import('@uppy/xhr-upload')).default
    const DragDrop = (await import('@uppy/drag-drop')).default
    const ProgressBar = (await import('@uppy/progress-bar')).default

    console.log('hekllo')
    this.uppy = new Uppy({ autoProceed: true, restrictions: { maxNumberOfFiles: 1 } })
          .use(
            DragDrop, { target: this.filePickerTarget }
          )
          .use(
            XHRUpload, { endpoint: '/upload/csv' }
          )
          .use(
            ProgressBar, { target: this.progressBarTarget, hideAfterFinish: false }
          )

    this.uppy.on('complete', (result) => {
      const filesAdded = result.successful.map((file) => file.response.body)
      this.addFile(filesAdded[0])
      this.uppy.reset()
    })
  }

  addFile (file) {
    this.sourceFileInputTarget.value = JSON.stringify(file)
    this.fileNameTarget.innerText = file.metadata.filename
    this.fileSizeTarget.innerText = humanFileSize(file.metadata.size)
    this.formContainerTarget.classList.remove('hidden')
    this.filePickerTarget.classList.add('hidden')
  }
}
